module.exports = __webpack_public_path__ + "static/img/default_new_zh-CN.89ce500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map/v2/default/default_new_zh-CN.png
// module id = U06M
// module chunks = 24